export const MIN_SELECT_LIST_WIDTH = 304
